export default __webpack_public_path__ + "63e9eefbf47c7d6786b9d2befda87145.png";